import { render } from "./Discussions.vue?vue&type=template&id=14e8c64c&scoped=true"
import script from "./Discussions.vue?vue&type=script&lang=js"
export * from "./Discussions.vue?vue&type=script&lang=js"

import "./Discussions.vue?vue&type=style&index=0&id=14e8c64c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e8c64c"]])

export default __exports__